<template>
  <!-- Desktop: tabs horizontales con iconos + texto -->
  <div v-if="!isMobile" class="text-blue px-8 pb-4 rounded-[50px] w-[95%] max-w-[1320px] mx-auto">
    <VaTabs v-model="activeTab" grow color="secondary" hide-slider
      class="py-2 px-1 bg-primary text-white rounded-[50px]">
      <template #tabs>
        <template v-for="(route, index) in navigationRoutes.routes" :key="index">
          <VaTab v-if="!route?.children" :name="route?.name" :class="[
            'btn-rounded py-4 flex items-center',
            activeTab === route?.name ? 'bg-info text-white' : 'bg-transparent text-white hover:bg-secondary/30',
          ]" @click="navigateTo(route?.name)">
            <VaIcon :name="route?.meta?.icon || 'dashboard'" class="mr-2" :class="{
          'material-symbols-outlined': activeTab !== route.name,
        }" />
            {{ t(route?.displayName || 'Sin nombre') }}
          </VaTab>
        </template>
      </template>
    </VaTabs>
  </div>

  <!-- Tablet-->
  <!-- Móvil: -->
  <div v-else class="mobile-bottom-bar bg-white">
    <div v-for="(route, index) in navigationRoutes.routes" :key="index"
      class="tab-icon flex flex-col items-center justify-center" :class="{ active: activeTab === route.name }"
      @click="navigateTo(route.name)">
      <VaIcon :name="route.meta?.icon || 'dashboard'" :size="activeTab === route.name ? '30px' : '20px'"
        class="transition-all duration-200" :class="{
          'text-primary': activeTab === route.name,
          'text-info material-symbols-outlined': activeTab !== route.name,
        }" 
        />
      <span class="mt-1 text-[8px] sm:text-xs md:text-sm"
       :class="{
        'text-primary': activeTab === route.name,
        'text-info': activeTab !== route.name,
      }">
        {{ t(route.displayName || 'Sin nombre') }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import navigationRoutes from './NavigationRoutes'

const { t } = useI18n()
const router = useRouter()
const route = useRoute()

const windowWidth = ref(window.innerWidth)

function onResize() {
  windowWidth.value = window.innerWidth
}

onMounted(() => {
  window.addEventListener('resize', onResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', onResize)
})

const isMobile = computed(() => windowWidth.value <= 820)

const activeTab = ref<string | null>(route.name as string)

function navigateTo(name: string) {
  if (name) {
    activeTab.value = name
    router.push({ name })
  }
}
</script>

<style scoped>
.mobile-bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background-color: var(--va-primary);
  color: aliceblue;
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 100;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.tab-icon {
  flex: 1;
  text-align: center;
  padding: 8px;
  color: white;
  cursor: pointer;
  user-select: none;
}

.tab-icon.active {
  background-color: rgba(120, 255, 30, 0.1);
  border-radius: 12px;
  transition: all 0.2s ease;
}
</style>
